'use strict';

exports.__esModule = true;

var _Circles = require('./Circles');

var _Circles2 = _interopRequireDefault(_Circles);

var _Lines = require('./Lines');

var _Lines2 = _interopRequireDefault(_Lines);

var _Paths = require('./Paths');

var _Paths2 = _interopRequireDefault(_Paths);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Circles: _Circles2.default,
  Lines: _Lines2.default,
  Paths: _Paths2.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./packages/extra/node_modules/react-svg-textures/lib/index.js
// module id = 9
// module chunks = 0